import {useEffect, ReactText} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useSnackbar} from 'notistack';
import {clearNotification} from './services/actions';
import {getNotifications} from './services/selectors';

let displayed: ReactText[] = [];

const Notifier = () => {
    const dispatch = useDispatch();
    const notifications = useSelector(getNotifications);
    const {enqueueSnackbar} = useSnackbar();

    const storeDisplayed = (key: ReactText) => {
        displayed = [...displayed, key];
    };

    const removeDisplayed = (key: ReactText) => {
        displayed = [...displayed.filter((el) => el !== key)];
    };

    useEffect(() => {
        notifications.forEach(({message, key, variant}) => {
            if (displayed.includes(key)) return;

            enqueueSnackbar(message, {
                key,
                variant,
                onExited: (event, key) => {
                    dispatch(clearNotification(key));
                    removeDisplayed(key);
                }
            });

            storeDisplayed(key);
        });
    }, [notifications, dispatch, enqueueSnackbar]);

    return null;
};

export default Notifier;
